import { render, staticRenderFns } from "./GalleryListCreatorLayout.vue?vue&type=template&id=ed5781e8&scoped=true"
import script from "./GalleryListCreatorLayout.vue?vue&type=script&lang=js"
export * from "./GalleryListCreatorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5781e8",
  null
  
)

export default component.exports